import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from "./components/landingpage/About";
import RestPage from "./components/landingpage/ResturantPage";
import Body from "./components/landingpage/Body";
const root = ReactDOM.createRoot(document.getElementById("root"));
const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Body />,
      },
      {
        path: "/resturant/:id",
        element: <RestPage />,
      },
    ],
  },
  {
    path: "/about",
    element: <About />,
  },
]);
root.render(<RouterProvider router={appRouter} />);
/**
 * const approuter=createBrowserRouter([
 * {path:"/",
 * element:<App/>
 * children:[
 * {
 * path:"/"
 * element:<Body/>
 * }]
 * }])
 */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
